<template>
  <settings-modal class="t-payment-identify-recipient-modal">
    <template slot="heading">Identify recipient</template>

    <profile-select
      v-model="recipient"
      class="t-profile-field"
      :transaction-party-type="TRANSACTION_PARTY_TYPES.RECIPIENT"
    />

    <profile-data-form-group
      v-if="hasRecipient"
      :profile="recipient"
      :account.sync="form.recipient"
      :account-options="internalRecipientAccounts"
      :transaction-party-type="TRANSACTION_PARTY_TYPES.RECIPIENT"
    />

    <v-text-field
      v-model="form.comment"
      class="t-comment-field"
      label="Identify recipient comment"
      hint="Required field"
      persistent-hint
      :counter="1000"
      :error-messages="getValidationErrorMessage('comment')"
    />

    <error-alert :error="error" />

    <template slot="actions">
      <v-btn
        color="light-blue darken-3"
        class="t-confirm-button"
        flat
        :disabled="isConfirmButtonDisabled"
        @click="onConfirmButtonClick"
      >confirm</v-btn>

      <v-btn
        color="light-blue darken-3"
        class="t-cancel-button"
        flat
        @click="onCancelButtonClick"
      >cancel</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Constants
  import { TRANSACTION_PARTY_TYPES } from '@/models/Transaction'

  // Events
  import { EVENT_PAYMENT_UPDATE } from '@/events/payments'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import PaymentApi from '@/services/Api/PaymentApi'

  // Mixins
  import form from '@/mixins/form'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'
  import ProfileSelect from '@/components/ui/ProfileSelect'
  import ProfileDataFormGroup from '@/components/payments/ProfileDataFormGroup'
  import ProfileApi, { ProfileAccountsApiPayload } from '@/services/Api/ProfileApi'

  export default {
    name: 'PaymentIdentifyRecipientModal',
    components: {
      SettingsModal,
      ErrorAlert,
      ProfileSelect,
      ProfileDataFormGroup
    },
    mixins: [form],
    data () {
      return {
        identifyRecipientRequest: new ApiRequest(PaymentApi.identifyRecipientByAccountant),
        recipientProfileAccountsApiRequest: new ApiRequest(ProfileApi.fetchAccounts, ProfileAccountsApiPayload),
        recipient: {},
        internalRecipientAccounts: [],
        form: {
          recipient: null,
          comment: null
        },
        requiredFields: [
          'recipient',
          'comment'
        ],
        TRANSACTION_PARTY_TYPES
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      paymentId () {
        return this.modal.data.paymentId
      },
      loading () {
        return this.identifyRecipientRequest.loading
      },
      error () {
        return this.identifyRecipientRequest.error
      },
      isConfirmButtonDisabled () {
        return !this.isFormFilled || this.loading
      },
      hasRecipient () {
        return this.recipient.id !== undefined
      }
    },
    watch: {
      recipient (recipient) {
        this.setFieldValue('recipient', '')

        this.recipientProfileAccountsApiRequest
          .execute(recipient.id)
          .then((accounts) => {
            this.$set(this, 'internalRecipientAccounts', accounts)
          })
          .catch(() => {})
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onConfirmButtonClick () {
        this.identifyRecipientRequest
          .execute(this.paymentId, this.form)
          .then(this.paymentIdentifyRecipientSuccessHandler)
          .catch(() => {})
      },
      onCancelButtonClick () {
        this.closeModal()
      },
      paymentIdentifyRecipientSuccessHandler () {
        this.$eventHub.$emit(EVENT_PAYMENT_UPDATE)
        this.closeModal()

        setTimeout(() => {
          this.showModal({
            name: 'SuccessFlashModal',
            data: { message: 'Payment recipient has been successfully identified.' }
          })
        }, 100)
      }
    }
  }
</script>
